import { createFileRoute } from '@tanstack/react-router';
import { CompanyPageBySlug } from '../../features/directory';

export const Route = createFileRoute('/portal/companies/$slug')({
  component: function CompanyBySlugRoute() {
    const { slug } = Route.useParams();
    return <CompanyPageBySlug slug={slug} />;
  },
});
